var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7H8.25V16H9.75V7Z",
    fill: "#54545C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7H11.25V16H12.75V7Z",
    fill: "#54545C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7H5.25V16H6.75V7Z",
    fill: "#54545C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H12.5V1C12.5 0.45 12.05 0 11.5 0H6.5C5.95 0 5.5 0.45 5.5 1V3H0V5H1.18005L2.5 20H15.5L16.8201 5H18V3ZM7 1.5H11V3H7V1.5ZM13.67 18H4.32996L3.18005 5H14.8101L13.66 18H13.67Z",
    fill: "#54545C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin2);
export default __webpack_public_path__ + "static/media/bin2.2ecece2c90f8d68dda9c13de258711c3.svg";
export { ForwardRef as ReactComponent };